import { render } from "./ReseauLanding.vue?vue&type=template&id=8164a4c4&scoped=true"
import script from "./ReseauLanding.vue?vue&type=script&lang=js"
export * from "./ReseauLanding.vue?vue&type=script&lang=js"

import "./ReseauLanding.vue?vue&type=style&index=0&id=8164a4c4&lang=scss&scoped=true"

import exportComponent from "/srv/ewigo-local-code/minisite/releases/20261028142257-afc99f34de38fbb8c9a48d510159883af3f0ac39/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8164a4c4"]])

export default __exports__